export async function playAudioStream(audioCtx,stream){
  console.log('open playAudioStream');
  let ctx = new (window.AudioContext || window.webkitAudioContext) ();
  ctx.resume();

  const source = ctx.createMediaStreamSource(stream);
  source.connect(ctx.destination);

  stream.onend = (e) => {
    console.log('close playAudioStream');
    source.stop();
    ctx.close();
    ctx = null;
  }

  return ctx;
}

// https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement/Audio

playAudioStreamWithAudioElement.audio = new Audio();

export async function playAudioStreamWithAudioElement(stream){
  const audio = playAudioStreamWithAudioElement.audio;

  audio.pause();
  audio.src = null;
  audio.srcObject = null;
  audio.srcObject = stream;

  audio.oncanplay = (e) => { // or oncanplaythrough
    try { audio.play(); } catch(e) {console.error(e);}
  }
}
